<!--
 * @Author: tfq
 * @Date: 2025-09-23 10:38:22
 * @LastEditTime: 2026-01-22 11:13:59
 * @Description: 
-->
<template>
  <div class="stoneInfo">
    <TitleModel title="石料信息" />
    <div class="stoneInfoDetail">
      <Sheet :tableData="tableProcess(mainStone)" />

      <div class="otherStone" v-if="otherStone.length !== 0">
        <van-tabs v-model="active" :line-height="0" title-active-color="#333">
          <van-tab v-for="(item, index) in otherStone" :key="index" :title="'副石' + (index + 1)">
            <Sheet :tableData="tableProcess(item, '副')" />
          </van-tab>
        </van-tabs>
      </div>
      <p class="note">*人工测量存在误差，请以实际重量为准</p>
    </div>
  </div>
</template>

<script>
import Sheet from "@/components/sheet";
import TitleModel from "../TitleModel.vue";
export default {
  props: {
    stoneInfoData: {
      type: Array,
      default: () => [],
    },
  },
  components: { TitleModel, Sheet },
  data() {
    return {
      active: 0,
      otherStone: [],
      mainStone: {},
    };
  },
  created() {
    this.stoneInfoData.map((item) => {
      if (item.main == 0) {
        this.otherStone.push(item);
      } else {
        this.mainStone = item;
      }
    });
  },
  methods: {
    tableProcess(data = {}, flag = "主") {
      return [
        { label: `${flag}石名`, value: data.name || '' },
        { label: `${flag}石重`, value: data.weight || '' },
        { label: "数量", value: data.quantity || '' },
        { label: "总重", value: data.weightTotal ? `${data.weightTotal}${data.unit || ''}` : '' },
        { label: "形状", value: data.shape || '' },
        { label: "净度", value: data.clarity || '' },
        { label: "切工", value: data.cutting || '' },
      ]
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-tabs__wrap {
  height: 88px !important;

  .van-tabs__nav--line {
    padding-bottom: 0 !important;
  }

  .van-tab {
    position: relative;
    color: #666666;
    font-size: 28px;

    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 1px;
      height: 32px;
      background: #E2E4EA;
    }

    &:first-child:before {
      display: none;
    }
  }

  .van-tab--active {
    color: #333;
    font-size: 32px;
    font-family: PingFang SC, PingFang SC;

    .van-tab__text {
      position: relative;
      z-index: 0;

      &:after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 8px;
        background: #EA9052;
        border-radius: 8px;
        z-index: -1;
      }
    }
  }

}

::v-deep .van-tabs__content {
  background: #fff !important;
}

.stoneInfo {
  margin-top: 24px;
  background: #fff;

  .stoneInfoDetail {
    padding: 0 24px 24px;
  }

  .note {
    margin: 24px 0 0;
    text-align: center;
    line-height: 33px;
    font-size: 24px;
    color: #999999;
  }
}
</style>
